/**
 * SettingsHomePage — index of arche-level config screens.
 * Links to Pipelines / Automations / Custom Fields / Saved Views.
 */

import { Link } from 'react-router-dom';
import { TrendingUp, Zap, ListChecks, Bookmark } from 'lucide-react';
import { ARCHE_PATH } from '../constants';

interface Props {
  holderId: string;
}

const SECTIONS = [
  {
    path: 'pipelines',
    icon: TrendingUp,
    label: 'Pipelines & stages',
    description: 'Sales pipelines, stages, default pipeline.',
  },
  {
    path: 'automations',
    icon: Zap,
    label: 'Automations',
    description: 'Trigger + action workflows.',
  },
  {
    path: 'custom-fields',
    icon: ListChecks,
    label: 'Custom fields',
    description: 'Per-entity custom field schemas (contact / company / deal).',
  },
  {
    path: 'saved-views',
    icon: Bookmark,
    label: 'Saved views',
    description: 'Reusable filter + sort presets per entity type.',
  },
] as const;

export function SettingsHomePage({ holderId: _holderId }: Props) {
  return (
    <div className="p-6 max-w-4xl mx-auto flex flex-col gap-4">
      <header>
        <h1 className="text-2xl font-semibold">Settings</h1>
        <p className="text-sm text-muted-foreground">
          Arche-level configuration. All settings are Holder-scoped.
        </p>
      </header>

      <div className="grid grid-cols-2 gap-4">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          return (
            <Link
              key={s.path}
              to={`${ARCHE_PATH}/settings/${s.path}`}
              className="rounded border border-border bg-card p-4 hover:border-primary transition-colors"
            >
              <Icon className="h-5 w-5 text-primary mb-2" />
              <h2 className="text-base font-medium">{s.label}</h2>
              <p className="text-sm text-muted-foreground mt-1">{s.description}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
